import { BuyOrNotifyMe } from "./BuyOrNotifyMe";
import Favorites from "./Favorites";
import { IconWrapper } from "./styles";
import { useProduct } from "../../hooks/internal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconButtons = function IconButtons() {
  var _buttons$favorites;
  var _useProduct = useProduct(),
    analyticsData = _useProduct.analyticsData,
    buttons = _useProduct.buttons,
    code = _useProduct.code,
    shades = _useProduct.shades,
    onFavoritesButtonClick = _useProduct.onFavoritesButtonClick;
  var _ref = (_buttons$favorites = buttons === null || buttons === void 0 ? void 0 : buttons.favorites) !== null && _buttons$favorites !== void 0 ? _buttons$favorites : {},
    enabled = _ref.enabled,
    trigger = _ref.trigger;
  return /*#__PURE__*/_jsxs(IconWrapper, {
    children: [/*#__PURE__*/_jsx(BuyOrNotifyMe, {}), enabled ? /*#__PURE__*/_jsx(Favorites, {
      code: code,
      shades: shades,
      analyticsData: analyticsData,
      onFavoritesButtonClick: trigger ? onFavoritesButtonClick : undefined
    }) : null]
  });
};
//# sourceMappingURL=IconButtons.js.map